import { render } from "./DetailMilkUi.vue?vue&type=template&id=d016ce9a&scoped=true"
import script from "./DetailMilkUi.vue?vue&type=script&lang=js"
export * from "./DetailMilkUi.vue?vue&type=script&lang=js"

import "./DetailMilkUi.vue?vue&type=style&index=0&id=d016ce9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d016ce9a"

export default script